// src/common/staticData/auditFieldMappings.ts
export const entityFieldMappings: Record<string, { label: string; value: string }[]> = {
    ICD: [
        { label: "code", value: "code" },
        { label: "Short Description", value: "shortDescription" },
        { label: "Short Description (Arabic)", value: "shortDescriptionAr" },
        { label: "Description", value: "description" },
        { label: "Description (Arabic)", value: "descriptionAr" },
    ],
    Company: [
        { label: "Name", value: "name" },
        { label: "Customer", value: "customerId" },
        { label: "Customer Name", value: "customerName" },
        { label: "Phone No", value: "phoneNo" },
        { label: "Email", value: "email" },
        { label: "Website", value: "webSite" },
        { label: "Mobile No", value: "mobileNo" },
        { label: "Logo", value: "logo" },
        { label: "Country", value: "countryId" },
        //{ label: "Country", value: "country" },
        { label: "City ", value: "cityId" },
        //{ label: "City", value: "city" },
        { label: "Area", value: "area" },
        { label: "Street No", value: "streetNo" },
        { label: "Address", value: "address" },
        { label: "Latitude", value: "latitude" },
        { label: "Longitude", value: "longitude" },
        { label: "Note", value: "note" },
        { label: "Status", value: "status" },
        //{ label: "Type", value: "type" },
    ],
    Claim: [
        { label: "Claim Date", value: "claimDate" },
        //{ label: "Policy Code", value: "policyCode" },
        //{ label: "Plan ", value: "planId" },
        //{ label: "Plan Name", value: "planName" },
        //{ label: "Customer ", value: "customerId" },
        //{ label: "Customer Name", value: "customerName" },
        //{ label: "Company ", value: "companyId" },
        //{ label: "Company Name", value: "companyName" },
        //{ label: "Currency ISO Code", value: "currencyISOCode" },
        { label: "Policy Holder", value: "policyHolderId" },
        //{ label: "Card Number", value: "cardNumber" },
        //{ label: "Policy Holder Name", value: "policyHolderName" },
        { label: "Patient", value: "patientId" },
        //{ label: "Patient Name", value: "patientName" },
        { label: "Medical Provider", value: "medicalProviderId" },
        //{ label: "Medical Provider Name", value: "medicalProviderName" },
        { label: "Is In Network", value: "isInNetwork" },
        { label: "Consultant Name", value: "consultantName" },
        { label: "Visit Date", value: "visitDate" },
        { label: "Consultant Fee", value: "consultantFee" },
        { label: "Medicine Amount", value: "medicineAmount" },
        { label: "Lab Test Amount", value: "labTestAmount" },
        { label: "Total Amount", value: "totalAmount" },
        { label: "Approved Amount", value: "approvedAmount" },
        { label: "Reason", value: "reason" },
        { label: "Reference No", value: "referenceNo" },
        { label: "Bank Detail", value: "bankDetailId" },
        { label: "Comment", value: "comment" },
        { label: "Status", value: "status" },
    ],
    MedicalProvider: [
        //{ label: "Code", value: "code" },
        { label: "Name", value: "name" },
        { label: "Name (Arabic)", value: "nameAr" },
        { label: "Address", value: "address" },
        { label: "Address (Arabic)", value: "addressAr" },
        { label: "Country", value: "countryId" },
        //{ label: "Country", value: "country" },
        { label: "Country (Arabic)", value: "countryAr" },
        { label: "City", value: "cityId" },
        //{ label: "City", value: "city" },
        { label: "Currency", value: "currencyId" },
        //{ label: "ISO Code", value: "isoCode" },
        { label: "Telephone No", value: "telephoneNo" },
        { label: "Email", value: "email" },
        { label: "Profile Picture", value: "profilePicture" },
        { label: "Provider Type", value: "providerTypeId" },
        { label: "Is In Network", value: "isInNetwork" },
        { label: "State", value: "state" },
        { label: "State (Arabic)", value: "stateAr" },
        { label: "Is Active", value: "isActive" },
    ],
    ProviderType: [
        //{ label: "Id", value: "id" },
        { label: "Name", value: "name" },
        { label: "Description", value: "description" },
        //{ label: "Status", value: "status" },
    ],
    ServiceCategory: [
        { label: "Name", value: "name" },
        { label: "Name (Arabic)", value: "nameAr" },
        { label: "Description", value: "description" },
        { label: "Description (Arabic)", value: "descriptionAr" },
        { label: "Is Active", value: "isActive" },
    ],
    ServiceCategoryItem: [
        { label: "Service Category", value: "serviceCategoryId" },
        { label: "Code", value: "code" },
        { label: "Name", value: "name" },
        { label: "Name (Arabic)", value: "nameAr" },
        { label: "Description", value: "description" },
        { label: "Description (Arabic)", value: "descriptionAr" },
        { label: "Is Active", value: "isActive" },
    ],
    ClaimStatus: [
        { label: "Status", value: "status" },
        { label: "Approved Amount", value: "approvedAmount" },
        { label: "Reason", value: "reason" },
    ],






   
};
